import React from 'react';
import PropTypes from 'prop-types';
import styles from './ModernModal.module.css';

export default function ModernModal({ isOpen, onClose, title, size = 'md', children }) {
  if (!isOpen) return null;

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') onClose();
  };

  return (
    <div
      className={styles.overlay}
      onClick={handleBackdrop}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
      tabIndex={-1}
    >
      <div className={`${styles.modal} ${styles[size]}`}>
        {title && (
          <div className={styles.header}>
            <h3 className={styles.title}>{title}</h3>
            <button className={styles.close} onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>
        )}
        {!title && (
          <button
            className={styles.close}
            onClick={onClose}
            style={{ position: 'absolute', top: '0.75rem', right: '0.75rem', zIndex: 1 }}
            aria-label="Close"
          >
            ×
          </button>
        )}
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
}

ModernModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  children: PropTypes.node,
};